module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    staticClass: "is-info",
    attrs: {
      "title": "Vinse",
      "subtitle": "A directory of multiplayer games on Ripple"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_vm._m(0), _vm._v(" "), (_vm.matches === null) ? _c('div', {
    staticClass: "container box"
  }, [_vm._v("\n      Loading matches...\n    ")]) : _c('div', {
    staticClass: "container box"
  }, [_vm._l((_vm.matches), function(match) {
    return _c('article', {
      key: match.ID,
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(match.Name))]), _vm._v(" "), _c('timeago', {
      attrs: {
        "auto-update": 30,
        "since": match.CreatedAt,
        "title": match.CreatedAt
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('a', {
      staticClass: "button",
      attrs: {
        "href": '/match/' + match.ID
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToMatch(match)
        }
      }
    }, [_vm._m(1, true)])])])
  }), _vm._v(" "), _c('paginator', {
    attrs: {
      "right-disabled": _vm.matches.length < 100
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container box content"
  }, [_c('p', [_vm._v("\n        Welcome to Vinse. Vinse is a website from which you can see all the\n        multiplayer matches that are happening right now on Ripple. On this\n        page, you can see all the multiplayer matches, sorted by time of\n        creation. Please note, though, that in order for a match to pop up\n        here, at least one score must have been submitted.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc3f2be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 144
// module chunks = 1